import { createContext, useContext } from 'react';

const UserAgentContext = createContext({
	browser: null,
	device: null,
	os: null,
});

export const ConfigContext = createContext({
	acceptedFileTypes: null,
	enableCloudTransfer: true,
	enableFaceDetection: true,
	faceDetectionThreshold: null,
});

const nonEmptyString = (str) =>
	str && typeof str === 'string' && str.trim().length > 0;

const strCmp = (str1, str2) => {
	if (nonEmptyString(str1) && nonEmptyString(str2)) {
		if (str1.toLowerCase()?.includes(str2.toLowerCase())) {
			return true;
		}
	}
	return false;
};

export const useUserAgentContext = () => {
	const { browser, device, os } = useContext(UserAgentContext);

	// need to determine if we're in android or ios
	if (
		strCmp(os?.name, 'ios') ||
		strCmp(device?.vendor, 'apple') ||
		strCmp(device?.model, 'iphone') ||
		strCmp(browser?.name, 'safari')
	) {
		return 'ios';
	} else {
		return 'android';
	}
};

export default UserAgentContext;
